import { translateFr as tfr } from "@/i18n";
export const negCard = "rounded-2xl border border-border dark:border-white/10 bg-card dark:bg-surface";

export const VALIDITY_FR = {
  active: "Valide", expiring_soon: tfr("Expire bientôt"), expires_today: tfr("Expire aujourd'hui"),
  expired: tfr("Expirée"), superseded: tfr("Remplacée"), accepted: tfr("Acceptée"), rejected: tfr("Refusée"),
  withdrawn: tfr("Retirée"), closed: tfr("Clôturée"),
};

export function validityTone(state) {
  if (state === "expired" || state === "expires_today") return "text-red-500 border-red-500/40 bg-red-500/10";
  if (state === "expiring_soon") return "text-amber-500 border-amber-500/40 bg-amber-500/10";
  if (state === "active") return "text-emerald-500 border-emerald-500/30 bg-emerald-500/5";
  return "text-muted-foreground border-border dark:border-white/10";
}

export function remainingLabel(validUntil, state, tf) {
  if (state === "superseded") return tf("Remplacée");
  if (!validUntil) return null;
  const ms = new Date(validUntil).getTime() - Date.now();
  const days = Math.floor(ms / 86400000);
  if (state === "expired") {
    const d = Math.max(1, Math.floor(-ms / 86400000) || 1);
    return `${tf("Expirée depuis")} ${d} ${d > 1 ? tf("jours") : tf("jour")}`;
  }
  if (state === "expires_today") return tf("Expire aujourd'hui");
  if (days <= 0) return tf("Expire aujourd'hui");
  if (days === 1) return tf("Expire demain");
  if (days <= 3) return `${tf("Expire dans")} ${days} ${tf("jours")}`;
  return `${tf("Valable encore")} ${days} ${tf("jours")}`;
}

export function fmtDeadline(validUntil, locale) {
  if (!validUntil) return "";
  const d = new Date(validUntil);
  return `${d.toLocaleDateString(locale, { day: "2-digit", month: "2-digit", year: "numeric" })} · ${d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })}`;
}

export function isoToLocalInput(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}

export const NEG_STATUS_FR = {
  draft: tfr("Brouillon"), offer_received: tfr("Offre reçue"), under_review: "En analyse",
  counter_prepared: tfr("Contre-offre préparée"), counter_sent: tfr("Contre-offre envoyée"),
  awaiting_response: tfr("En attente de réponse"), revised_received: tfr("Nouvelle offre reçue"),
  negotiating: tfr("En négociation"), verbal_agreement: tfr("Accord verbal"), final_received: tfr("Contrat final reçu"),
  ready_to_sign: tfr("Prêt à signer"), signed: tfr("Signé"), rejected: tfr("Refusé"), withdrawn: tfr("Retiré"), closed: tfr("Clôturé"),
};

export const DOC_KIND_FR = {
  offer: tfr("Offre"), counter_offer: tfr("Contre-offre"), final_contract: tfr("Contrat final"),
  annex: "Annexe", other: "Autre",
};

export const EXT_STATUS_FR = {
  pending_review: tfr("À vérifier"), needs_review: tfr("À clarifier"), not_found: tfr("Non trouvé"),
  accepted: tfr("Validé"), modified_and_accepted: tfr("Corrigé et validé"), ignored: tfr("Ignoré"),
};

export const RECON_STATUS_FR = {
  match: "Conforme", difference: tfr("Écart"), missing: "Manquant",
  new_unexpected: "Inattendu", needs_review: tfr("À vérifier"),
};

export const RESOLUTION_FR = {
  confirm_match: tfr("Confirmé conforme"), accept_change: tfr("Modification acceptée"),
  request_correction: tfr("Correction demandée"), needs_clarification: tfr("À clarifier"),
};

export const EXT_TONE = {
  pending_review: "text-amber-500 bg-amber-500/10 border-amber-500/25",
  needs_review: "text-sky-500 bg-sky-500/10 border-sky-500/25",
  not_found: "text-muted-foreground bg-white/[0.04] border-border dark:border-white/10",
  accepted: "text-emerald-500 bg-emerald-500/10 border-emerald-500/25",
  modified_and_accepted: "text-emerald-500 bg-emerald-500/10 border-emerald-500/25",
  ignored: "text-muted-foreground bg-white/[0.04] border-border dark:border-white/10",
};

export const RECON_TONE = {
  match: "text-emerald-500 bg-emerald-500/10 border-emerald-500/25",
  difference: "text-amber-500 bg-amber-500/10 border-amber-500/25",
  missing: "text-red-500 bg-red-500/10 border-red-500/25",
  new_unexpected: "text-purple-500 bg-purple-500/10 border-purple-500/25",
  needs_review: "text-sky-500 bg-sky-500/10 border-sky-500/25",
};

export function fmtTermValue(vtype, currency, val, locale, tf) {
  if (val === null || val === undefined || val === "") return "—";
  if (vtype === "money") {
    try { return new Intl.NumberFormat(locale, { style: "currency", currency: currency || "EUR", maximumFractionDigits: 0 }).format(val); }
    catch { return `${val} ${currency || ""}`; }
  }
  if (vtype === "percent") return `${val} %`;
  if (vtype === "bool" || typeof val === "boolean") return val ? tf("Oui") : tf("Non");
  return tf(String(val));
}

export function extractedValue(ext) {
  const v = ext.accepted_value || ext.value || {};
  if (["money", "number", "percent"].includes(ext.vtype)) return v.amount;
  if (ext.vtype === "bool") return v.value_bool;
  return v.value_text;
}

export function fmtSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}
